(function ($) {
  //  alert('bosop');
  var options = {
    // vertical offset in px before element is first unpinned
    offset : 0,
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 100,
        down: 50
    },
    // scroll tolerance in px before state changes
    tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "ptx-tinyfooternav",
        // when scrolling up
        pinned : "ptx-tinyfooternav--pinned",
        // when scrolling down
        unpinned : "ptx-tinyfooternav--unpinned",
        // when above offset
        top : "ptx-tinyfooternav--top",
        // when below offset
        notTop : "ptx-tinyfooternav--not-top",
        // when at bottom of scroll area
        bottom : "ptx-tinyfooternav--bottom",
        // when not at bottom of scroll area
        notBottom : "ptx-tinyfooternav--not-bottom",
        // when frozen method has been called
        frozen: "ptx-tinyfooternav--frozen",
        // multiple classes are also supported with a space-separated list
        pinned: "ptx-tinyfooternav--pinned"
    },
    // element to listen to scroll events on, defaults to `window`
    // scroller : someElement,
    // callback when pinned, `this` is headroom object
    onPin : function() {},
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {},
    // callback when above offset, `this` is headroom object
    onTop : function() {},
    // callback when below offset, `this` is headroom object
    onNotTop : function() {},
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {}
};

if(false){
  $(".ptx-tinyfooternav").headroom(options);
}

// alert('test');
// ".ptx-tinyfooternav__controls button, .ptx-tinyfooternav__center" 
$( ".ptx-tinyfooternav__controls button" ).on('click',function() {
  // alert('click');
  $(".ptx-tinyfooternav").toggleClass("ptx-tinyfooternav--minimized");
});



})(jQuery);
   
   